import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("ph_lang") || "de");
    useEffect(() => {
        localStorage.setItem("ph_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);
    const t = (path) => {
        const parts = path.split(".");
        let cur = translations[lang] || translations.de;
        for (const p of parts) {
            if (cur && p in cur) cur = cur[p];
            else return path;
        }
        return cur;
    };
    return (
        <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>
    );
}

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
};
